import React, {useEffect, useRef, useState} from "react";
import classes from "./CatalogProducts.module.css"

// модуль для карточки продукта
import Product from "../../../Product/Product";

// фотографии
import filter from "../../../../img/filters.png"

import АМР_4753_10 from "../../../../img/АМР_4753-10.png"
import АМР_4753_102 from "../../../../img/АМР_4753-102.png"
import АМР_4753_103 from "../../../../img/АМР_4753-103.png"
import АМР_4753_20 from "../../../../img/АМР_4753-20.png"
import АМР_4753_30 from "../../../../img/АМР_4753-30.png"
import АМР_4753_40 from "../../../../img/АМР_4753-40.png"

import questionPng from "../../../../img/question.png"


const CatalogProducts = () => {

    // данные с сервера
    const [data, setData] = useState()
    // данные после применения фильтров и поиска
    const [newData, setNewData] = useState("")
    const [finder, setFinder] = useState("")

    // фильтры
    const [filter10, setFilter10] = useState("")
    const [filter10Click, setFilter10Click] = useState(1)
    const [filter20, setFilter20] = useState("")
    const [filter20Click, setFilter20Click] = useState(1)
    const [filter30, setFilter30] = useState("")
    const [filter30Click, setFilter30Click] = useState(1)
    const [filter40, setFilter40] = useState("")
    const [filter40Click, setFilter40Click] = useState(1)
    const [filter0, setFilter0] = useState("")
    const [filter0Click, setFilter0Click] = useState(1)

    const [displayFilter, setDisplayFilter] = useState("none")
    const [isClickFilter, setIsClickFilter] = useState(0)

    const [isClickSearch, setIsClickSearch] = useState(0)

    // показываем статус загрузки сервера
    const [paramentsLoading, setParamentsLoading] = useState(classes.closeLoad)
    
    const filter10Ref = useRef(null)
    const filter20Ref = useRef(null)
    const filter30Ref = useRef(null)
    const filter40Ref = useRef(null)
    const filter0Ref = useRef(null)

    // получаем дату с сервера
    useEffect(() => {
        setParamentsLoading(classes.viewLoad)
        try {
            fetch(process.env.REACT_APP_FETCH_URL + "/api/catalog", {
                method: "GET",
                // headers: { 'Content-Type': 'application/json' },
            })
            .then(response=>response.json())
            .then((response) => {
                /*
                    записываем данные в привычном формате:
                    idE: 4
                    idPrE: "4753-40"
                    paramDescr: "Измерительный преобразователь гидростатического уровня АМР"
                */
                var elemResp = []
                response.map((e) => {
                    const idE = e.id
                    const idPrE = e.id_paraments
                    const paramDescr = e.param_descr
                    elemResp.push({idE, idPrE, paramDescr})
                })
                setData(elemResp.reverse())
                setParamentsLoading(classes.closeLoad)
            })
        } catch(e) {
            console.log(e)
            setParamentsLoading(classes.closeLoad)
        }
        
    }, [])

    // учитываем поиск
    useEffect(()=> {
        if (data !== undefined) {
            setNewData(data.filter((e)=>e.idPrE.includes(finder)))
        }
    }, [data, isClickSearch])

    // ставим фильтры
    useEffect(()=> {

        if (data !== undefined) {
            if (filter10 !== "") {
                setNewData(data.filter((e)=>e.idPrE.includes(filter10)))
            } else if (filter20 !== "") {
                setNewData(data.filter((e)=>e.idPrE.includes(filter20)))
            } else if (filter30 !== "") {
                setNewData(data.filter((e)=>e.idPrE.includes(filter30)))
            } else if (filter40 !== "") {
                setNewData(data.filter((e)=>e.idPrE.includes(filter40)))
            } else if (filter0 !== "") {
                setNewData(data)
            } else {
                setNewData(data)
            }
        }
    }, [filter10, filter20, filter30, filter40])

    // при установке фильтров меняем значения в стейтах фильтров
    useEffect(()=>{
        const onCheck = () => {
            setFilter10("")
            setFilter20("")
            setFilter30("")
            setFilter40("")
            if (filter10Ref.current.checked){
                setFilter10("4753-10")
            } else if (filter20Ref.current.checked){
                setFilter20("4753-20")
            } else if (filter30Ref.current.checked){
                setFilter30("4753-30")
            } else if (filter40Ref.current.checked){
                setFilter40("4753-40")
            }
        }
        onCheck()
    }, [filter10Click, filter20Click, filter30Click, filter40Click, filter0Click])
    


    return (
        <div className={classes.catalogProducts}>

            {/* блок с фильтрами и поиском */}
            <div className={classes.inputsCatalog}>
                <button onClick={()=>{setIsClickFilter(isClickFilter + 1); isClickFilter%2===0 ? setDisplayFilter("flex") : setDisplayFilter("none")}} className={classes.filter} title="Фильтры"><img src={filter} alt="фильтры"/></button>
                <input onChange={e=>{setFinder(e.target.value)}} type="text" placeholder="Искать"/>
                <button onClick={()=>{setIsClickSearch(isClickSearch + 1)}} className={classes.searchButton} title="Найти товар по запросу">Найти</button>
            </div>

            {/* блок с выбором фильтра */}
            <div className={classes.checkboxes} style={{display: displayFilter}}>
                <div><input onClick={()=>{setFilter10Click(filter10Click + 1)}} ref={filter10Ref} id="10" type="radio" name="filter" /><label for="10">AMP 4753-10</label></div>
                <div><input onClick={()=>{setFilter20Click(filter20Click + 1)}} ref={filter20Ref} id="20" type="radio" name="filter" /><label for="20">AMP 4753-20</label></div>
                <div><input onClick={()=>{setFilter30Click(filter30Click + 1)}} ref={filter30Ref} id="30" type="radio" name="filter" /><label for="30">AMP 4753-30</label></div>
                <div><input onClick={()=>{setFilter40Click(filter40Click + 1)}} ref={filter40Ref} id="40" type="radio" name="filter" /><label for="40">AMP 4753-40</label></div>
                <div><input onClick={()=>{setFilter0Click(filter0Click + 1)}} ref={filter0Ref} id="0" type="radio" name="filter" /><label for="0">Нет фильтров</label></div>
            </div>

            {/* вывод продукции */}
            <div className={classes.products}>
                <div className={classes.loading + " " + paramentsLoading}><div className={classes.circle}></div></div>
                {newData !== "" ? newData.map((e)=>{
                    if (e.idPrE === "4753-10") {
                    return <>
                    <div className={classes.divProduct}>
                    <Product
                        imgSrc={АМР_4753_10} 
                        imgAlt={e.idPrE} 
                        text={"АМР " + e.idPrE}
                        exText=""
                    /></div>
                    <div className={classes.divProduct}>
                    <Product
                        imgSrc={АМР_4753_102} 
                        imgAlt={e.idPrE} 
                        text={"АМР " + e.idPrE}
                        exText="Искро-взрывобезопасный"
                    /></div>
                    <div className={classes.divProduct}>
                    <Product
                        imgSrc={АМР_4753_103} 
                        imgAlt={e.idPrE} 
                        text={"АМР " + e.idPrE}
                        exText="Искрозащищенный"
                    /></div>
                    </>
                    }
                    if (e.idPrE === "4753-20") {
                        return <>
                        <div className={classes.divProduct}>
                        <Product
                            imgSrc={АМР_4753_20} 
                            imgAlt={e.idPrE} 
                            text={"АМР " + e.idPrE}
                            exText=""
                        /></div>
                        </>
                    }
                    if (e.idPrE === "4753-30") {
                        return <>
                        <div className={classes.divProduct}>
                        <Product
                            imgSrc={АМР_4753_30} 
                            imgAlt={e.idPrE} 
                            text={"АМР " + e.idPrE}
                            exText=""
                        /></div>
                        </>
                    }
                    if (e.idPrE === "4753-40") {
                        return <>
                        <div className={classes.divProduct}>
                        <Product
                            imgSrc={АМР_4753_40} 
                            imgAlt={e.idPrE} 
                            text={"АМР " + e.idPrE}
                            exText=""
                        /></div>
                        </>
                    }
                    return <>
                        <div className={classes.divProduct}>
                        <Product
                            imgSrc={questionPng} 
                            imgAlt={e.idPrE} 
                            text={"АМР " + e.idPrE}
                            exText=""
                        /></div>
                        </>
                    }) : ()=>{return <><p>Ожидаем ответ сервера...</p><br/><div className={classes.loading}></div></>}}
            </div>
        </div>
    )
}

export default CatalogProducts